import calculate from "@/components/common/i18n/quote/calculate";
import todoList from "@/components/common/i18n/quote/todoList";
import sourcingProductI18n from "@/components/common/i18n/quote/sourcingProductI18n";

export default {
    zh:{
        calculate:calculate.zh,
        todoList:todoList.zh,
        sourcingProduct:sourcingProductI18n.zh,
        applyNo:'报价申请单号'
    },
    en:{
        calculate:calculate.en,
        todoList: todoList.en,
        sourcingProduct:sourcingProductI18n.en,
        applyNo:'Apply No.'
    }
}
